import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';
import { ModalMessageService } from './services/modal-message.service';
import { OMITIR_ERROR_GLOBAL } from './http-context';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(
    public modalMessageService: ModalMessageService
  ){}

  private reintentos(req: HttpRequest<any>): number {
    const idempotente = req.method === 'GET' || req.method === 'HEAD';
    return idempotente ? 3 : 0;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry({ count: this.reintentos(req) }),
      map(resp => {
        if (resp instanceof HttpResponse) {
          const token = resp.headers.get('Authorization');
          if (token) {
            //TODO: nombre de sesionstorage dinamico
            sessionStorage.setItem('segurito', token)
          }

        }
        return resp;
      }),
      catchError(err => {

        if (req.context.get(OMITIR_ERROR_GLOBAL)) {
          return throwError(() => err);
        }

        if (err.status == 401) {
          // alert('Su sesión ha expirado');
          this.modalMessageService.openModal(
            '¡Ups!',
            'Su sesión ha expirado',
            false,
            false
          );
          // window.location.href = 'https://www.colmena.cl';
        } else {
          // alert(err.error);
          this.modalMessageService.openModal(
            '¡Ups!',
            err.error,
            false,
            false
          );
          
        }
        return of(err);
      }));
  }
}
